export const enTranslations = {
  // Navigation
  'nav.title': 'Smart Café',
  'nav.portal': 'Portal',
  'nav.table': 'Table',
  'nav.kitchen': 'Kitchen',
  'nav.admin': 'Admin',
  'nav.portalAdmin': 'Portal Admin',
  'nav.orders': 'Orders',

  // Table Screen
  'table.header.label': 'Table Order Terminal',
  'table.header.title': 'Table 1 - Menu',
  'table.header.items': 'item(s) in cart',

  'table.sidebar.categories': 'Categories',
  'table.sidebar.system': 'System Status',
  'table.sidebar.terminal': 'Terminal',
  'table.sidebar.server': 'Server',
  'table.sidebar.online': 'Online',
  'table.sidebar.stable': 'Stable',

  'table.main.menu': 'Menu',
  'table.main.featured': 'Featured dishes',
  'table.main.items': 'items',
  'table.main.addOrder': 'Add to Order',
  'table.main.dishPreview': 'Dish Preview',
  'table.main.categoryAll': 'All',

  'table.main.category.breakfast': 'Breakfast',
  'table.main.category.dessert': 'Dessert', 
  'table.main.category.drinks': 'Drinks',
  'table.main.category.lunch': 'Lunch',

  'table.aside.summary': 'Order Summary',
  'table.aside.empty': 'Cart is empty',
  'table.aside.selectItems': 'Select items from menu to begin',
  'table.aside.items': 'Items',
  'table.aside.total': 'Total',
  'table.aside.create': 'Create Order',
  'table.aside.confirm': 'Confirm order',
  'table.confirm.title': 'Your order',
  'table.confirm.ok': 'OK',
  'table.confirm.edit': 'Edit',
  'table.confirm.delete': 'Delete',
  'table.aside.callWaiter': 'Call waiter',
  'table.aside.waiterCalled': 'Waiter already called',
  'table.aside.lastOrder': 'Last Order',
  'table.aside.currentOrder': 'Current order',
  'table.aside.orderNumber': 'Order',
  'table.main.inCart': 'In cart',

  'table.voice.title': 'Voice Assistant',
  'table.voice.status': 'Status',
  'table.voice.listening': '🎤 Listening',
  'table.voice.ready': '✓ Ready',
  'table.voice.lastCommand': 'Last Command',
  'table.voice.awaiting': 'Awaiting voice input',
  'table.voice.feedback': 'Feedback',
  'table.voice.transcript': 'Transcript',
  'table.voice.none': '(none)',
  'table.voice.examples': 'Try saying:',
  'table.voice.example1': 'show drinks',
  'table.voice.example2': 'add one latte',
  'table.voice.example3': 'clear cart',
  'table.voice.example4': 'create order',
  'table.voice.button': 'Hey Lume',
  'table.voice.unsupported': 'Voice recognition is not supported in this browser',

  // Kitchen Screen
  'kitchen.header.label': 'Kitchen Station',
  'kitchen.header.title': 'Order Queue',
  'kitchen.header.active': 'active',

  'kitchen.filter.all': 'All Orders',
  'kitchen.empty.ready': '🍳',
  'kitchen.empty.message': 'No orders in queue',
  'kitchen.empty.subtext': 'Ready for service when orders come in',

  'kitchen.order.label': 'Order',
  'kitchen.order.items': 'item',
  'kitchen.order.table': 'Table',
  'kitchen.order.total': 'Total',
  'kitchen.order.items.label': 'Items:',
  'kitchen.order.markAs': 'Mark as',

  // Admin Screen
  'admin.header.label': 'Admin Dashboard',
  'admin.header.title': 'Order Summary',
  'admin.header.totalLabel': 'total',
  'admin.loginJournal.currentUser': 'Signed in',
  'admin.loginJournal.eyebrow': 'LOGIN JOURNAL',
  'admin.loginJournal.title': 'Login Journal',
  'admin.loginJournal.refresh': 'Refresh',
  'admin.loginJournal.clear': 'Clear list',
  'admin.loginJournal.clearing': 'Clearing...',
  'admin.loginJournal.loadError': 'Failed to load login journal.',
  'admin.loginJournal.clearError': 'Failed to clear login journal.',
  'admin.loginJournal.empty': 'No login records yet.',
  'admin.loginJournal.time': 'Time',
  'admin.loginJournal.fullName': 'Full Name',
  'admin.loginJournal.role': 'Role',
  'admin.loginJournal.loginType': 'Login Method',
  'admin.loginJournal.accessKey': 'Key / ID',
  'admin.loginJournal.device': 'Device / Source',
  'admin.loginJournal.typeManual': 'Username and password',
  'admin.loginJournal.typeInitialSetup': 'Initial setup',
  'admin.loginJournal.typeQr': 'QR code',
  'admin.loginJournal.typeLogout': 'Sign out',
  'admin.loginJournal.roleAdmin': 'Admin',
  'admin.loginJournal.roleKitchen': 'Kitchen',
  'admin.loginJournal.roleStaff': 'Staff',
  'admin.loginJournal.roleGuest': 'Guest',
  'admin.access.eyebrow': 'App access',
  'admin.access.title': 'App access settings',
  'admin.access.description': 'Add staff members who will use the app. Each staff member signs in with their own username and password.',
  'admin.access.adminSection': 'Your administrator access',
  'admin.access.currentKey': 'Username',
  'admin.access.username': 'Username',
  'admin.access.newPassword': 'New password',
  'admin.access.repeatPassword': 'Repeat password',
  'admin.access.newRecoveryCode': 'New recovery identification code',
  'admin.access.repeatRecoveryCode': 'Repeat identification code',
  'admin.access.usersTitle': 'App users',
  'admin.access.addUser': 'Add user',
  'admin.access.fullName': 'Full name',
  'admin.access.password': 'Password',
  'admin.access.role': 'Role',
  'admin.access.roleAdmin': 'Admin',
  'admin.access.roleKitchen': 'Kitchen',
  'admin.access.roleStaff': 'Staff',
  'admin.access.delete': 'Delete',
  'admin.access.save': 'Save',
  'admin.access.saving': 'Saving...',
  'admin.access.passwordMismatch': 'Passwords do not match',
  'admin.access.recoveryCodeMismatch': 'Identification codes do not match',
  'admin.access.duplicateKey': 'A user with this username already exists',
  'admin.access.reservedUsername': 'This username is reserved by the system.',
  'admin.access.saved': 'Access saved',
  'admin.access.cannotDeleteLastAdmin': 'You cannot delete the last administrator',
  'admin.access.cannotDeleteCurrentUser': 'You cannot delete the current user',
  'admin.access.loading': 'Loading access settings...',
  'admin.access.loadError': 'Could not load access settings.',
  'admin.access.saveError': 'Could not save access settings.',
  'admin.access.addUserError': 'Could not add the user',
  'admin.access.requiredError': 'Fill in full name, username, password, and role.',
  'admin.access.adminRequiredError': 'Enter the administrator username.',
  'admin.access.startWorkday': 'Close and start workday',
  'admin.access.empty': 'No access users added yet.',
  'admin.appSettings.eyebrow': 'App parameters',
  'admin.appSettings.title': 'App settings',
  'admin.appSettings.description': 'Set venue details and use the local links to connect kitchen and staff devices to this computer.',
  'admin.appSettings.venueName': 'Venue name',
  'admin.appSettings.venueDescription': 'Description',
  'admin.appSettings.venueDescriptionHint': 'Short description for the mobile version',
  'admin.appSettings.venueOpeningHours': 'Opening hours by weekday',
  'admin.appSettings.venuePhone': 'Venue phone',
  'admin.appSettings.venueAddress': 'Venue address',
  'admin.appSettings.venuePostalCode': 'Postal code',
  'admin.appSettings.venueLocation': 'Venue location',
  'admin.appSettings.venueLocationHint': 'Confirm the venue point for portal display.',
  'admin.appSettings.venueLocationConfirm': 'Confirm location',
  'admin.appSettings.venueLocationSaving': 'Locating...',
  'admin.appSettings.venueLocationSaved': 'Venue location saved for the portal.',
  'admin.appSettings.venueLocationDenied': 'Location access was denied. Allow access and try again.',
  'admin.appSettings.venueLocationError': 'Could not save venue location.',
  'admin.appSettings.venueLocationPrivacyHint': 'If it does not work: System Settings → Privacy & Security → Location Services → allow access for the app.',
  'admin.appSettings.monday': 'Monday',
  'admin.appSettings.tuesday': 'Tuesday',
  'admin.appSettings.wednesday': 'Wednesday',
  'admin.appSettings.thursday': 'Thursday',
  'admin.appSettings.friday': 'Friday',
  'admin.appSettings.saturday': 'Saturday',
  'admin.appSettings.sunday': 'Sunday',
  'admin.appSettings.dayWorking': 'Open',
  'admin.appSettings.dayOff': 'Day off',
  'admin.appSettings.dayOffNote': 'Closed this day',
  'admin.appSettings.kitchenUrl': 'Kitchen computer login URL',
  'admin.appSettings.staffUrl': 'Staff computer login URL',
  'admin.appSettings.copy': 'Copy',
  'admin.appSettings.linkCopied': 'Link copied',
  'admin.appSettings.save': 'Save settings',
  'admin.appSettings.saving': 'Saving...',
  'admin.appSettings.saved': 'Settings saved',
  'admin.appSettings.requiredVenueName': 'Enter venue name',
  'admin.appSettings.invalidVenuePhone': 'Enter a valid venue phone number with country code',
  'admin.appSettings.invalidVenueEmail': 'Enter a valid venue email',
  'admin.appSettings.networkHint': 'All devices must be connected to the same Wi‑Fi network. Internet is not required, but the main computer must stay on.',
  'admin.appSettings.localOnly': 'Works without internet inside the local network',
  'admin.appSettings.loading': 'Loading app settings...',
  'admin.appSettings.loadError': 'Could not load app settings.',
  'admin.appSettings.saveError': 'Could not save app settings.',
  'admin.appSettings.completeProfileFirst': 'Fill in the venue profile first (name, phone, e-mail) and save it — then you can hide prices on the storefront.',
  'admin.backups.eyebrow': 'Database backups',
  'admin.backups.title': 'Backup and restore',
  'admin.backups.body': 'Create local database backups and restore the app from an available snapshot when needed. Administrator password confirmation is required for restore.',
  'admin.backups.loading': 'Loading backups...',
  'admin.backups.create': 'Create backup now',
  'admin.backups.creating': 'Creating backup...',
  'admin.backups.refresh': 'Refresh',
  'admin.backups.latest': 'Latest created backup',
  'admin.backups.emptyWindow': 'No backup yet',
  'admin.backups.restore': 'Restore',
  'admin.backups.restoreTitle': 'Confirm restore',
  'admin.backups.restoreBody': 'To reinstall the app from the selected backup, enter the current administrator password. The current database will be replaced, and the system will create a safety copy first.',
  'admin.backups.passwordPlaceholder': 'Enter administrator password',
  'admin.backups.confirmRestore': 'Confirm restore',
  'admin.backups.cancelRestore': 'Cancel',
  'admin.backups.restoring': 'Restoring...',
  'admin.backups.windowHour': 'Last hour',
  'admin.backups.windowDay': 'Last day',
  'admin.backups.windowWeek': 'Last week',
  'admin.backups.windowMonth': 'Last month',
  'admin.backups.loadError': 'Could not load backups.',
  'admin.backups.createError': 'Could not create the backup.',
  'admin.backups.restoreError': 'Could not restore the database from backup.',
  'admin.backups.createSuccess': 'Backup created.',
  'admin.backups.restoreSuccess': 'Database restored from backup.',
  'admin.backups.autoHint': 'Automatic backups are off by default. When enabled, the app will automatically maintain 4 backup slots: 1 hour, 1 day, 1 week, and 1 month.',
  'admin.backups.autoEnabled': 'Auto backups: on',
  'admin.backups.autoDisabled': 'Auto backups: off',
  'admin.backups.autoSaving': 'Saving...',
  'admin.backups.autoEnableSuccess': 'Automatic backups enabled.',
  'admin.backups.autoDisableSuccess': 'Automatic backups disabled.',
  'admin.backups.autoToggleError': 'Could not change automatic backup mode.',

  'admin.empty.message': 'No orders yet. Waiting for first order from table.',

  'admin.stats.title': 'Statistics',
  'admin.stats.totalOrders': 'Total Orders',
  'admin.stats.totalRevenue': 'Paid Revenue',
  'admin.stats.pendingPayments': 'Pending Payments',

  'admin.breakdown.title': 'Status Breakdown',

  'admin.orders.title': 'All Orders',
  'admin.orders.empty': 'No orders yet.',
  'admin.orders.tableLabel': 'Table',
  'admin.orders.markServed': 'Mark as Served',
  'admin.orders.markPaid': 'Mark as Paid',
  'admin.orders.markCancelled': 'Mark as Cancelled',
  'admin.orders.waiterCall': 'Waiter call',
  'admin.orders.itemSingular': 'item',
  'admin.orders.itemsPlural': 'items',
  'admin.orders.timeLabel': 'Time',

  // Admin Menu Management
  'admin.menu.title': 'Menu Management',
  'admin.menu.addItem': 'Add Item',
  'admin.menu.editItem': 'Edit Item',
  'admin.menu.name': 'Name',
  'admin.menu.category': 'Category',
  'admin.menu.selectCategory': 'Select Category',
  'admin.menu.price': 'Price',
  'admin.menu.image': 'Image URL',
  'admin.menu.description': 'Description',
  'admin.menu.available': 'Show this dish in menu and storefront',
  'admin.menu.active': 'Active',
  'admin.menu.inactive': 'Hidden',
  'admin.menu.save': 'Save',
  'admin.menu.create': 'Create',
  'admin.menu.cancel': 'Cancel',
  'admin.menu.empty': 'No menu items yet.',
  'admin.menu.edit': 'Edit',
  'admin.menu.delete': 'Delete',
  'admin.menu.continue': 'Continue',

  'admin.tables.title': 'Table Management',
  'admin.tables.add': 'Add Table',
  'admin.tables.panelTitle': 'Add Table',
  'admin.tables.completedTitle': 'Setup complete',
  'admin.tables.completedBadge': 'Done',
  'admin.tables.completedDescription': 'Copy the table link and open it on the target monitor, then install the page as an app.\n\nYou can also download QR codes and place them on the tables so visitors can open the digital menu and order from their phone.\n\nBefore launching, make sure every device is connected to the same local cafe network.',
  'admin.tables.close': 'Close',
  'admin.tables.continue': 'Continue',
  'admin.tables.edit': 'Edit Table',
  'admin.tables.name': 'Display Name',
  'admin.tables.accessCode': 'Access Code',
  'admin.tables.pin': 'PIN',
  'admin.tables.status': 'Status',
  'admin.tables.capacity': 'Capacity',
  'admin.tables.note': 'Note',
  'admin.tables.active': 'Active',
  'admin.tables.inactive': 'Inactive',
  'admin.tables.id': 'ID',
  'admin.tables.save': 'Save',
  'admin.tables.create': 'Create',
  'admin.tables.cancel': 'Cancel',
  'admin.tables.delete': 'Delete',
  'admin.tables.activate': 'Activate',
  'admin.tables.deactivate': 'Deactivate',
  'admin.tables.empty': 'No tables configured yet.',
  'admin.tables.deleteConfirm': 'Are you sure you want to delete this table?',
  'admin.tables.deleteWithOrdersConfirm': 'Close related orders and delete this table?',
  'admin.tables.lanEyebrow': 'Venue local network',
  'admin.tables.lanBody': 'Guest phones on the venue Wi‑Fi use this address directly, even without internet access.',
  'admin.tables.lanUnavailable': 'The local LAN address is not available yet. The local backend still works, but table QR links need a reachable Wi‑Fi host address.',
  'admin.tables.guestLanTitle': 'LAN guest link',
  'admin.tables.copyLanLink': 'Copy link',
  'admin.tables.openLanLink': 'Open table',
  'admin.tables.copied': 'Copied',
  'admin.tables.qrPreview': 'Table QR',
  'admin.tables.qrCaption': 'Show this QR on the admin screen or use the LAN link below on a phone connected to the same venue Wi‑Fi.',
  'admin.tables.downloadQr': 'Download QR',
  'admin.tables.printCard': 'Print card',
  'admin.tables.printInstruction': 'Scan the QR code to open the menu',
  'admin.tables.printWifiHint': 'Connect to the venue Wi-Fi and scan the QR code to open the menu',
  'admin.tables.printPinLabel': 'Entry PIN',

  'admin.storefront.eyebrow': 'Venue storefront',
  'admin.storefront.title': 'Entrance photo, interior, and passive storefront screen',
  'admin.storefront.body': 'Set up the storefront before table mode: entrance image, interior images, and a passive rotation of active dishes.',
  'admin.storefront.open': 'Open storefront',
  'admin.storefront.monitorUrl': 'Storefront monitor URL',
  'admin.storefront.showPrices': 'Show dish prices',
  'admin.storefront.showPricesHint': 'When enabled, the price appears only on storefront dish cards.',
  'admin.storefront.pricesOn': 'Prices shown',
  'admin.storefront.pricesOff': 'Prices hidden',
  'admin.storefront.photoFile': 'Venue photo',
  'admin.storefront.photoType': 'Photo type',
  'admin.storefront.photoSort': 'Order',
  'admin.storefront.upload': 'Upload photo',
  'admin.storefront.note': 'Use 1 entrance photo and up to 2 interior photos. Vertical media is automatically adapted for horizontal displays.',
  'admin.storefront.portalEntranceNote': 'Only the “Entrance” photo is sent to the portal. Interior, storefront, and dish images stay local.',
  'admin.storefront.portalEntranceBadge': 'Portal photo',
  'admin.storefront.typeEntrance': 'Entrance',
  'admin.storefront.typeInterior': 'Interior',
  'admin.storefront.orderLabel': 'Order:',
  'admin.storefront.remove': 'Remove',
  'admin.storefront.empty': 'No storefront photos uploaded yet.',
  'admin.storefront.continue': 'Continue',
  'admin.storefront.photoRequired': 'Choose a storefront image first.',
  'admin.storefront.uploadError': 'Could not upload the storefront photo.',

  // Order Statuses
  'status.new': 'New Order',
  'status.inProgress': 'In progress',
  'status.ready': 'Ready to Serve',
  'status.served': 'Served',
  'status.paid': 'Paid',
  'status.cancelled': 'Cancelled',

  // Payment Statuses
  'payment.pending': 'Payment Pending',
  'payment.paid': 'Paid',
  'payment.failed': 'Payment Failed',
  'payment.cancelled': 'No payment required',

  'table.header.menuSuffix': 'Menu',
  'table.header.accessCode': 'Access',
  'table.header.inactive': 'This table screen is inactive.',
  'table.header.unassigned': 'This table screen is not configured yet.',
  'table.access.label': 'Table Access',
  'table.access.openingTable': 'You are opening order table',
  'table.access.titleFallback': 'Table Screen',
  'table.access.loading': 'Loading table access...',
  'table.access.slug': 'Table URL',
  'table.access.prompt': 'Enter the PIN code to open the ordering screen for this table.',
  'table.access.pinLabel': 'PIN / Password',
  'table.access.unlock': 'Unlock Table',
  'table.access.unlocking': 'Unlocking...',
  'table.access.pinInvalid': 'Invalid PIN',
  'table.access.missingSlug': 'Open a table-specific URL such as /table/t1 to use this kiosk screen.',
  'table.access.keypadHint': 'The PIN pad works with both touch and mouse.',
  'table.access.clear': 'Clear',
  'table.access.deviceTitle': 'Touch-First Access',
  'table.access.deviceBody': 'Built for table monitors and tablets with large controls and a lightweight kiosk-style unlock flow.',
  'table.access.rememberTitle': 'Remembered On Device',
  'table.access.rememberBody': 'Once unlocked, this device stays authorized until the table PIN changes or access is cleared.',
  'table.intro.eyebrow': 'Guest table screen',
  'table.intro.body': 'Before the interactive menu appears, the guest sees a calm intro scene for this table with venue imagery and today’s active dishes.',
  'table.intro.openMenu': 'Open menu',
  'table.intro.startOrder': 'Start order',
  'table.intro.entranceKicker': 'Venue entrance',
  'table.intro.interiorKicker': 'Interior',
  'table.intro.entranceTitle': 'Welcome to the venue',
  'table.intro.interiorTitle': 'Inside the space',
  'table.intro.entranceBody': 'The first screen introduces the place and gently leads the guest toward the menu of this table.',
  'table.intro.interiorBody': 'Interior imagery keeps the waiting scene alive before the guest moves into the interactive order flow.',
  'table.intro.entranceBadge': 'Entrance',
  'table.intro.interiorBadge': 'Interior',
  'table.intro.photoPlaceholder': 'This screen will show venue photos and active menu items for the table intro.',
  'table.intro.dishKicker': 'Active dish',
  'table.intro.dishBadge': 'Today’s menu',
  'table.intro.dishBody': 'Only active dishes are used in the table intro, and the same dishes remain available once the guest opens the menu.',
  'table.intro.welcome': 'Welcome',
  'table.intro.todayMenu': 'Today’s menu',
  'table.intro.rotationNote': 'slides auto-rotate',
  'table.intro.emptyKicker': 'Table start',
  'table.intro.emptyTitle': 'The table screen is ready for the menu',
  'table.intro.emptyBody': 'Once venue photos and active dishes are added, they will automatically participate in the intro rotation for this table.',
  'table.intro.emptyBadge': 'Waiting',
  'table.intro.highlightOne': 'The table first presents the venue and only then opens the ordering interface.',
  'table.intro.highlightTwo': 'Vertical media keeps its aspect ratio and fills the horizontal stage with a soft blurred background.',
  'table.intro.highlightThree': 'Only active dishes are used in both the intro and the menu.',
  'table.intro.highlightFour': 'The table link stays consistent through the full guest path: QR opens the right table directly.',
  'table.waiter.label': 'Waiter workspace',
  'table.waiter.title': 'Tables in service',
  'table.waiter.activeTable': 'Selected table',
  'table.waiter.loadingTables': 'Loading tables...',
  'table.waiter.markServed': 'Mark order as served',
  'table.waiter.markPaid': 'Mark order as paid',
  'table.waiter.markCancelled': 'Cancel order',
  'table.waiter.resolveCall': 'Clear waiter call',
  'table.waiter.noTables': 'No tables have been created yet. Add them in admin.',
  'table.waiter.noActiveTables': 'There are no active tables right now. Activate at least one table in admin.',
  'storefront.eyebrow': 'Local storefront',
  'storefront.title': 'A passive venue screen before table mode',
  'storefront.body': 'This screen cycles through the entrance, the interior, and active dishes on a horizontal display. It stays passive with no ordering controls.',
  'storefront.backToEditor': 'Back to editor',
  'storefront.info.photos': 'The loop begins with the entrance and interior of the venue.',
  'storefront.info.menu': 'Only active dishes are included in the storefront rotation.',
  'storefront.info.passive': 'This mode is display-only and does not open guest ordering.',
  'storefront.info.local': 'The content stays local and is ready for autonomous operation.',
  'storefront.photo.entranceKicker': 'Entrance',
  'storefront.photo.interiorKicker': 'Interior',
  'storefront.photo.entranceTitle': 'Venue entrance',
  'storefront.photo.interiorTitle': 'Venue interior',
  'storefront.photo.entranceBody': 'The first screen introduces the venue entrance and gives the audience a clear sense of arrival.',
  'storefront.photo.interiorBody': 'The next screen deepens the mood with one of the interior views of the venue.',
  'storefront.photo.entranceBadge': 'Entrance photo',
  'storefront.photo.interiorBadge': 'Interior photo',
  'storefront.photo.placeholder': 'Upload vertical venue photos to start the storefront loop.',
  'storefront.dishKicker': 'Active dish',
  'storefront.dishBadge': 'Menu today',
  'storefront.dishEyebrow': 'Rotating menu item',
  'storefront.dishBody': 'An active dish appears in the storefront rotation and stays visible in the interactive table menu.',
  'storefront.dishPlaceholder': 'This dish does not have a photo yet. The storefront can still show the dish card without distorting the display.',
  'storefront.emptyKicker': 'Storefront setup',
  'storefront.emptyTitle': 'Add an entrance photo and active dishes',
  'storefront.emptyBody': 'After the first setup, the storefront will loop through venue photos and active menu items automatically.',
  'storefront.emptyBadge': 'Empty',

  // Portal
  'portal.kicker': 'Spatial Venue Portal',
  'portal.headline': 'Enter the living map of future venues',
  'portal.guidance.first': 'Approach a real venue system: download the kit, install the shell, open admin, or descend straight into a venue.',
  'portal.guidance.returning': 'Earth remembers your last venue. Pause, let the camera return, then continue into service or branch out to another city.',
  'portal.memory.label': 'Memory Of Place',
  'portal.memory.first': 'Choose one venue once and the entrance will remember where the next session should begin its return flight.',
  'portal.memory.returning': 'Your last venue remains staged on this device, so the portal can guide you back without losing the global view.',
  'portal.loading.label': 'Calibrating Earth',
  'portal.loading.body': 'Preparing the live map, venue data, and navigation layers.',
  'portal.scale.global': 'Global Orbit',
  'portal.scale.country': 'Country',
  'portal.scale.city': 'City',
  'portal.scale.district': 'District',
  'portal.scale.venue': 'Venue',
  'portal.interaction': 'Drag to rotate, pinch or wheel to zoom, tap signals to focus venues',
  'portal.timeline.download': 'Download',
  'portal.timeline.downloadValue': 'Get the venue brief',
  'portal.timeline.install': 'Install',
  'portal.timeline.installValue': 'Prepare the kiosk shell',
  'portal.timeline.enter': 'Enter',
  'portal.timeline.enterValue': 'Select a venue',
  'portal.editorial.title': 'Future Newspaper Modules',
  'portal.selectedVenue': 'Selected Venue',
  'portal.district': 'District',
  'portal.street': 'Street',
  'portal.status.live': 'Live',
  'portal.status.preview': 'Preview',
  'portal.status.offline': 'Offline',
  'portal.actions.download': 'Download for Windows',
  'portal.actions.install': 'Install Flow',
  'portal.actions.admin': 'Open Admin Portal',
  'portal.actions.enter': 'Enter Venue',
  'portal.actions.unavailable': 'Venue Offline',
  'portal.install.label': 'Install Path',
  'portal.install.body': 'A real venue launch starts with a device, a local shell, and a portal route that staff can trust immediately.',
  'portal.install.step1Title': '1. Download',
  'portal.install.step1Body': 'Send the venue brief to the device owner or installation partner.',
  'portal.install.step2Title': '2. Install',
  'portal.install.step2Body': 'Open the shell or browser wrapper on the destination screen and pin the staging URL.',
  'portal.install.step3Title': '3. Enter',
  'portal.install.step3Body': 'Use the remembered venue route and PIN flow to continue into the live table experience.',
  'portal.cards.local.kicker': 'Local First',
  'portal.cards.local.title': 'A venue entrance before a dashboard',
  'portal.cards.local.body': 'The first screen should orient guests, operators, and installers around a real place, not a generic software lobby.',
  'portal.cards.future.kicker': 'Future Module',
  'portal.cards.future.title': 'Install, admin, and live venue paths stay one gesture apart',
  'portal.cards.future.body': 'Practical actions remain visible at all times so immersion supports venue operations instead of replacing them.',
  'portal.cards.story.kicker': 'Editorial',
  'portal.cards.story.title': 'A digital newspaper front page for the venue network',
  'portal.cards.story.body': 'Short concept blocks explain what the system can become next without pushing the spatial map out of focus.',
  'portal.cards.assistant.kicker': 'Assistant',
  'portal.cards.assistant.title': 'Hints without noise',
  'portal.cards.assistant.body': 'Motion and copy stay calm, deliberate, and believable so the portal feels premium on phones, tablets, and wall displays.',
  'portal.rotating.seeker.title': 'Find the right place faster',
  'portal.rotating.seeker.body': 'Discover cafes and restaurants through a live spatial portal.',
  'portal.rotating.owner.title': 'Own a venue?',
  'portal.rotating.owner.body': 'Install the local promotion tool and appear inside the living portal.',
  'portal.business.hero.eyebrow': 'LIVING PORTAL',
  'portal.business.hero.title': 'The living portal is looking for new cafes and restaurants',
  'portal.business.hero.body': 'Join for free, find your venue in the system, and launch working software for local mode, advertising, and presence inside the portal.',
  'portal.business.hero.primary': 'Choose from the business list — cafes and restaurants',
  'portal.business.hero.secondary': 'Learn connection modes',
  'portal.business.hero.later': 'Later',
  'portal.business.modes.free.label': 'Free entry',
  'portal.business.modes.free.title': 'Join for free',
  'portal.business.modes.free.body': 'Local autonomous work is free. This mode is supported by advertising.',
  'portal.business.modes.silent.label': 'Silent local mode',
  'portal.business.modes.silent.title': 'Local work without advertising',
  'portal.business.modes.silent.body': 'Local work without the advertising layer is available by subscription.',
  'portal.business.modes.growth.label': 'Growth mode',
  'portal.business.modes.growth.title': 'Promotion inside the portal',
  'portal.business.modes.growth.body': 'Local work without advertising plus stronger visibility inside the live portal. Subscription.',
  'portal.business.entry.eyebrow': 'BUSINESS ENTRY',
  'portal.business.entry.title': 'Choose the venue type',
  'portal.business.entry.body': 'Select a business category first. The install path must stay available even without geolocation.',
  'portal.business.entry.placeholder': 'Cafes or restaurants',
  'portal.business.entry.option.cafe': 'Cafes',
  'portal.business.entry.option.restaurant': 'Restaurants',
  'portal.business.entry.install': 'Install app on this device',
  'portal.business.entry.locationFallback': 'Location is unavailable, but business entry stays open.',
  'portal.business.platform.eyebrow': 'BUSINESS ENTRY',
  'portal.business.platform.title': 'Choose a platform path',
  'portal.business.platform.windows.title': 'Windows',
  'portal.business.platform.windows.body': 'Download the local app for Windows',
  'portal.business.platform.windows.button': 'Download .exe',
  'portal.business.platform.mac.title': 'Mac',
  'portal.business.platform.mac.body': 'Run through the browser as an app window',
  'portal.business.platform.mac.button': 'Mac instructions',
  'portal.business.platform.portal.title': 'Portal',
  'portal.business.platform.portal.body': 'Work with a live portal connection',
  'portal.business.platform.portal.button': 'Open portal mode',
  'portal.business.mac.eyebrow': 'BROWSER INSTALL',
  'portal.business.mac.title': 'Install on Mac',
  'portal.business.mac.body': 'On Mac, the app is currently installed through the browser as a separate app window.',
  'portal.business.mac.safari.title': 'Safari',
  'portal.business.mac.safari.body': 'Open the portal in Safari and choose “Add to Dock”.',
  'portal.business.mac.chrome.title': 'Chrome',
  'portal.business.mac.chrome.body': 'Open the portal in Chrome and choose “Install app”.',
  'portal.business.mac.footer': 'This mode is suitable for local work, testing, and launch on Mac without a separate .dmg.',
  'portal.business.portal.eyebrow': 'PORTAL MODE',
  'portal.business.portal.title': 'Work with a live portal connection',
  'portal.business.portal.body': 'This mode stays connected to the live portal and lets the venue participate in discovery and promotion without replacing local work.',
  'portal.business.openPortal': 'Open portal',
  'portal.business.close': 'Close',
  'portal.banner.eyebrow': 'PORTAL',
  'portal.banner.message1': 'Open the portal and choose today’s events',
  'portal.banner.message2': 'Install your business tool for free and be seen on the events page',
  'portal.banner.message3': 'If your business is online, install HELFER online and use the best tools',
  'portal.support.label': 'Support',
  'admin.support.button': 'Support',
  'portal.voice.label': 'Voice assistant',
  'portal.voice.listening': 'Listening...',
  'portal.voice.speaking': 'Speak...',
  'portal.controls.eyebrow': 'BUSINESS ENTRY',
  'portal.controls.placeholder': 'Search cafes and restaurants',
  'portal.controls.option.venues': 'Cafes and restaurants',
  'portal.controls.option.online': 'HELFER for online specialists',
  'portal.controls.find': 'Open the venues map',
  'portal.controls.install': 'Install cafe app',
  'portal.controls.searchSubmit': 'Find',
  'portal.controls.searchEmpty': 'No venues found for this search.',
  'portal.mobile.nav.label': 'Portal navigation',
  'portal.mobile.nav.map': 'Map',
  'portal.mobile.nav.search': 'Search',
  'portal.mobile.nav.support': 'Support',
  'portal.mobile.nav.install': 'App',
  'portal.hero.titleMain': 'Working tools',
  'portal.hero.titleAccent': 'for your business',
  'portal.hero.body': 'Discover events, workflows and Helfer tools for cafes and restaurants. Everything in one place, ready to launch without extra setup.',
  'portal.hero.badge': 'New: a live venues map — real prices, menus and occupancy',
  'portal.hero.venuesNearby': '{n} venues already on the map — real-time prices, menus and occupancy',
  'portal.hero.chip.menu': 'Menu from the phone',
  'portal.hero.chip.storefront': 'Storefront on the street',
  'portal.hero.chip.tools': 'Floor & kitchen tools',
  'portal.hero.user.titleMain': 'Cafes and restaurants',
  'portal.hero.user.titleAccent': 'on a live map',
  'portal.hero.user.body': 'See what is open and how busy it is right now. Menu, reviews and directions — all in one place.',
  'portal.hero.user.chip.menu': 'Live menus & prices',
  'portal.hero.user.chip.occupancy': 'How busy right now',
  'portal.hero.user.chip.route': 'Route to the venue',
  'portal.hero.business.badge': 'Put your venue on the live map — guests nearby will find you',
  'portal.controls.userEyebrow': 'FIND A VENUE',
  'portal.venue.close': 'Close',
  'portal.venue.address': 'Address',
  'portal.venue.phone': 'Phone',
  'portal.venue.hours': 'Opening hours',
  'portal.venue.status': 'Status',
  'portal.venue.open': 'Open',
  'portal.venue.closed': 'Closed now',
  'portal.venue.photoSoon': 'Entrance photo coming soon',
  'portal.venue.occupancy.title': 'Real-time occupancy',
  'portal.venue.occupancy.detail': 'Active tables with an order: {ordered} of {active}',
  'portal.venue.occupancy.free': 'Available',
  'portal.venue.occupancy.moderate': 'Moderate',
  'portal.venue.occupancy.busy': 'Busy',
  'portal.map.legend.title': 'Occupancy',
  'portal.map.legend.reset': 'Reset',
  'portal.venue.navigation': 'Navigation',
  'portal.venue.distance': 'Distance: {value}',
  'portal.venue.openInMaps': 'Open in Maps',
  'portal.venue.walking': 'Walking',
  'portal.venue.driving': 'Driving',
  'portal.venue.minutes': '{n} min',
  'portal.venue.showMenu': 'View menu',
  'portal.venue.hideMenu': 'Hide menu',
  'portal.venue.reviews': 'Reviews',
  'portal.venue.reviewsCount': 'Reviews ({n})',
  'portal.venue.hideReviews': 'Hide reviews',
  'portal.venue.menu': 'Menu',
  'portal.venue.itemsCount': '{n} items',
  'portal.venue.allCategories': 'All',
  'portal.venue.noItems': 'No dishes in this category yet.',
  'portal.venue.noReviews': 'No reviews yet.',
  'portal.venue.leaveReview': 'Leave a review',
  'portal.venue.reviewPlaceholder': 'Write a short review about the venue',
  'portal.venue.saveReview': 'Save review',
  'portal.venue.guestAuthor': 'Portal guest',
  'portal.venue.uncategorized': 'Uncategorized',
  'portal.venue.unit.m': 'm',
  'portal.venue.unit.km': 'km',
  'portal.venue.day.mon': 'Mon',
  'portal.venue.day.tue': 'Tue',
  'portal.venue.day.wed': 'Wed',
  'portal.venue.day.thu': 'Thu',
  'portal.venue.day.fri': 'Fri',
  'portal.venue.day.sat': 'Sat',
  'portal.venue.day.sun': 'Sun',
  'portal.controls.back': 'Back',
  'portal.controls.locationDenied': 'Location is unavailable. You can still install the app.',
  'portal.controls.locationManual': 'Location is unavailable. Enter a city or venue name in the search — the map will open there.',
  'portal.controls.locationSecureContext': 'Open the portal over HTTPS or localhost to request location access.',
  'support.eyebrow': 'Support',
  'support.title': 'Contact support',
  'support.body': 'Leave your contact details and briefly describe the issue. We will send the request to support.',
  'support.fullName': 'Full name',
  'support.fullNamePlaceholder': 'Enter full name',
  'support.contact': 'Phone / messenger',
  'support.contactPlaceholder': 'For example, +353..., Telegram @...',
  'support.message': 'Request message',
  'support.messagePlaceholder': 'Describe the issue or question',
  'support.send': 'Send',
  'support.sending': 'Sending...',
  'support.cancel': 'Close',
  'support.success': 'Message sent to support',
  'support.validation': 'Fill in all fields',
  'support.error': 'Could not send message',
  'portal.events.sheet.eyebrow': 'VENUE MAP',
  'portal.events.sheet.title': 'Open the cafe and restaurant map',
  'portal.events.sheet.body': 'Continue in the browser or install the app to find nearby venues faster and return to the map without extra steps.',
  'portal.events.sheet.mapTitle': 'Live venue map',
  'portal.events.sheet.mapBody': 'See cafes and restaurants nearby, menus, reviews, routes and current occupancy in one place.',
  'portal.events.sheet.ios': 'iPhone / App Store',
  'portal.events.sheet.android': 'Android / Google Play',
  'portal.install.comingSoon': 'Soon',
  'portal.events.sheet.browser': 'Open in browser',
  'portal.install.sheet.eyebrow': 'BUSINESS ENTRY',
  'portal.install.sheet.title': 'HELFER for cafes and restaurants',
  'portal.install.sheet.body': 'Install the local app on the administrator computer to receive orders, manage the menu, track tables, and show the venue on the live portal map.',
  'portal.install.sheet.value1': 'Table orders go straight to the administrator and kitchen',
  'portal.install.sheet.value2': 'Menu items, prices, and photos update on the portal from the local app',
  'portal.install.sheet.value3': 'Room occupancy follows table statuses in real time',
  'portal.install.sheet.value4': 'Start with the basics without complicated setup or cloud dependency',
  'portal.install.sheet.note': 'Core work stays on the venue device.',
  'portal.install.sheet.trust': 'Core features are free. Showcase, sales statistics, and backups can be connected separately when they are needed.',
  'portal.install.windows.title': 'Windows',
  'portal.install.windows.body': 'Download the local app for Windows',
  'portal.install.windows.button': 'Download for Windows',
  'portal.install.mac.title': 'Mac',
  'portal.install.mac.body': 'Download the local app for macOS',
  'portal.install.mac.button': 'Download for Mac',
  'portal.install.portal.title': 'Portal',
  'portal.install.portal.body': 'Work with a live portal connection',
  'portal.install.portal.button': 'Open portal mode',
  'portal.install.mac.guide.eyebrow': 'BROWSER INSTALL',
  'portal.install.mac.guide.title': 'Install on Mac',
  'portal.install.mac.guide.body': 'On Mac, the app is currently installed through the browser as a separate app window.',
  'portal.install.mac.guide.safari.title': 'Safari',
  'portal.install.mac.guide.safari.body': 'Open the portal in Safari and choose “Add to Dock”.',
  'portal.install.mac.guide.chrome.title': 'Chrome',
  'portal.install.mac.guide.chrome.body': 'Open the portal in Chrome and choose “Install app”.',
  'portal.install.mac.guide.footer': 'This mode is suitable for local work, testing, and launch on Mac without a separate .dmg.',
  'portal.install.portal.guide.eyebrow': 'PORTAL MODE',
  'portal.install.portal.guide.title': 'Live portal connection',
  'portal.install.portal.guide.body': 'This mode works with a live portal connection and gives the venue participation in discovery and promotion.',
  'portal.install.online.eyebrow': 'HELFER ONLINE',
  'portal.install.online.title': 'Offer your knowledge and services in HELFER',
  'portal.install.online.body': 'A clear entry for specialists: create a profile, show courses and posts, build trust through reviews and help people find you in the feed.',
  'portal.install.online.bridgeKicker': 'For coaches, consultants, teachers and experts',
  'portal.install.online.bridgeText': 'A visitor should understand in seconds: publish your knowledge, build trust through reviews and be found in the feed.',
  'portal.install.online.features.title': 'What’s inside',
  'portal.install.online.feature1': 'Specialist profiles',
  'portal.install.online.feature2': 'Courses, services and useful posts',
  'portal.install.online.feature3': 'Reviews and trust on one page',
  'portal.install.online.feature4': 'Search through feed and filters',
  'portal.install.online.createProfile': 'Create specialist profile',
  'portal.install.online.createProfileBody': 'Register and set up a page with your services, courses and reviews.',
  'portal.install.online.viewFeed': 'View feed',
  'portal.install.online.viewFeedBody': 'See how publications, courses and offers look inside HELFER.',
  'portal.install.online.findSpecialist': 'Find a specialist',
  'portal.install.online.findSpecialistBody': 'Use filters, open an avatar and study the profile, courses and reviews.',
  'portal.install.online.learnMore': 'Learn more about HELFER',
  'portal.install.online.ios': 'iPhone / App Store',
  'portal.install.online.mac': 'Mac',
  'portal.install.online.windows': 'Windows',
  'portal.install.online.android': 'Android / Google Play',
  'portal.install.online.open': 'Open HELFER online',
  'portal.install.openPortal': 'Open portal',
  'portal.install.close': 'Close',
  'desktop.entry.eyebrow': 'Local app',
  'desktop.entry.title': 'Welcome to the venue management system',
  'desktop.entry.body': 'You installed the local tool for operating a cafe or restaurant.',
  'desktop.entry.video.eyebrow': 'Demo video',
  'desktop.entry.video.placeholder': 'A short demo can quickly show how management, placement, and daily workflow fit together inside the local system.',
  'desktop.entry.video.opened': 'The demo area is open. This can later host a local training video or a compact introduction for the team.',
  'desktop.entry.login.eyebrow': 'Access key sign-in',
  'desktop.entry.login.title': 'Enter the working environment',
  'desktop.entry.login.body': 'Enter the access key and password to open the local application under the correct role.',
  'desktop.entry.login.fieldLabel': 'Access key',
  'desktop.entry.login.placeholder': 'For example, ADMIN-LOCAL-01',
  'desktop.entry.login.submit': 'Sign in',
  'desktop.entry.login.loading': 'Signing in...',
  'desktop.entry.login.qrHint': 'You can also sign in by scanning a personal QR code.',
  'desktop.entry.login.error': 'The sign-in could not be completed. Check the access key.',
  'desktop.entry.qr.eyebrow': 'QR sign-in',
  'desktop.entry.qr.title': 'Sign in with a personal QR code',
  'desktop.entry.qr.body': 'If the QR code opens the app with an access token, sign-in happens automatically without a separate form.',
  'desktop.entry.qr.scanTitle': 'Scan the QR and open the app',
  'desktop.entry.qr.scanBody': 'Use a link like /login?token=... or app://login?token=... so the system can identify the user and record the sign-in immediately.',
  'desktop.entry.qr.detected': 'QR token detected',
  'desktop.start.eyebrow': 'Local start',
  'desktop.start.title': 'Welcome',
  'desktop.start.body': 'Choose the next step.',
  'desktop.start.brand.subtitle': 'Cafe and restaurant',
  'desktop.start.hero.titleLineOne': 'Welcome',
  'desktop.start.hero.titleLineTwo': 'to HELFER',
  'desktop.start.hero.body': 'A local app for managing your cafe or restaurant: orders, kitchen, staff and analytics — all in one place.',
  'desktop.start.hero.enterApp': 'Enter the app',
  'desktop.start.status.title': 'The app works locally',
  'desktop.start.status.body': 'All data is stored on this device',
  'desktop.start.visual.tables': 'Tables',
  'desktop.start.visual.tablesBody': 'Table management',
  'desktop.start.visual.orders': 'Orders',
  'desktop.start.visual.ordersBody': 'Order list',
  'desktop.start.visual.kitchen': 'Kitchen',
  'desktop.start.visual.kitchenBody': 'Kitchen screen',
  'desktop.start.visual.staff': 'Staff',
  'desktop.start.visual.staffBody': 'Staff management',
  'desktop.start.video.eyebrow': 'Demo screen',
  'desktop.start.video.title': 'Short demo',
  'desktop.start.video.placeholder': 'This area can hold a short introduction for the owner and venue team.',
  'desktop.start.video.opened': 'The demo area is active. It can quickly show startup, working screens, and service mode.',
  'desktop.start.video.note': 'A secondary area for a short product video or local walkthrough.',
  'desktop.start.video.play': 'Open demo',
  'desktop.start.login.eyebrow': 'Access key sign-in',
  'desktop.start.login.title': 'Open the local workspace',
  'desktop.start.login.body': 'Enter the access key and password. QR sign-in stays available separately.',
  'desktop.start.login.firstAdminEyebrow': 'First administrator login',
  'desktop.start.login.firstAdminKey': 'Access key',
  'desktop.start.login.firstAdminPassword': 'Password',
  'desktop.start.login.fieldLabel': 'Access key',
  'desktop.start.login.placeholder': 'For example, ADMIN-LOCAL-01',
  'desktop.start.login.passwordLabel': 'Password',
  'desktop.start.login.passwordPlaceholder': 'Enter the first-login password',
  'desktop.start.login.submit': 'Sign in',
  'desktop.start.login.loading': 'Signing in...',
  'desktop.start.login.reveal': 'Open sign in',
  'desktop.start.login.hide': 'Hide sign in',
  'desktop.start.login.qrHint': 'You can also sign in by scanning a personal QR code.',
  'desktop.start.login.error': 'The sign-in could not be completed. Check the access key.',
  'desktop.start.login.invalidCredentials': 'Invalid access key or password',
  'desktopWelcome.brandSubtitle': 'CAFE & RESTAURANT',
  'desktopWelcome.welcomeLine1': 'Welcome',
  'desktopWelcome.welcomeLine2': 'to HELFER',
  'desktopWelcome.description': 'A local app for managing your cafe or restaurant: orders, kitchen, staff and analytics — all in one place.',
  'desktopWelcome.enterApp': 'Enter the app',
  'desktopWelcome.localTitle': 'The app works locally',
  'desktopWelcome.localSubtitle': 'All data is stored on this device',
  'desktopWelcome.username': 'Username',
  'desktopWelcome.password': 'Password',
  'desktopWelcome.loginEyebrow': 'APP SIGN IN',
  'desktopWelcome.loginTitle': 'Enter access details',
  'desktopWelcome.loginSubtitle': 'Enter the username and password to open the working app.',
  'desktopWelcome.login': 'Sign in',
  'desktopWelcome.forgotPassword': 'Forgot password?',
  'desktopWelcome.initialSetupEyebrow': 'INITIAL ACCESS SETUP',
  'desktopWelcome.initialSetupTitle': 'Create administrator',
  'desktopWelcome.initialSetupSubtitle': 'Set administrator credentials. After that, staff will sign in with a username and password.',
  'desktopWelcome.adminFullName': 'Administrator full name',
  'desktopWelcome.repeatPassword': 'Repeat password',
  'desktopWelcome.recoveryCode': 'Recovery identification code',
  'desktopWelcome.repeatRecoveryCode': 'Repeat identification code',
  'desktopWelcome.saveAndEnter': 'Save and enter',
  'desktopWelcome.recoveryTitle': 'Access recovery',
  'desktopWelcome.enterIdentificationCode': 'Enter your identification code',
  'desktopWelcome.createNewPassword': 'Create a new password',
  'desktopWelcome.repeatNewPassword': 'Repeat new password',
  'desktopWelcome.recoverAccess': 'Recover access',
  'desktopWelcome.backToSignIn': 'Back to sign in',
  'desktopWelcome.recoverySuccess': 'Administrator password has been updated. Sign in with the new password.',
  'desktopWelcome.recoveryError': 'Could not restore access',
  'desktopWelcome.recoveryAdminOnly': 'Password recovery is available only for an administrator. Please contact the app administrator.',
  'desktopWelcome.supportRecoveryHint': 'If you forgot both your password and identification code, contact HELFER support.',
  'desktopWelcome.fillAllFields': 'Fill in all fields',
  'desktopWelcome.passwordsDoNotMatch': 'Passwords do not match',
  'desktopWelcome.identificationCodesDoNotMatch': 'Identification codes do not match',
  'desktopWelcome.invalidCredentials': 'Invalid username or password',
  'desktopWelcome.bootstrapAccessError': 'Could not open local administrator access.',
  'desktopWelcome.loginError': 'Could not sign in.',
  'desktopWelcome.invalidRecoveryCode': 'Invalid identification code',
  'desktopWelcome.recoveryCodeMissing': 'Recovery identification code is not configured. Sign in through HELFER support and set a new password.',
  'desktopWelcome.userNotFound': 'User not found',
  'desktopWelcome.saveAdministratorError': 'Could not save administrator',
  'desktopWelcome.duplicateUsername': 'A user with this username already exists',
  'desktopWelcome.qrCardScanHint': 'Scan with phone on the same network',
  'desktopWelcome.qrCardOr': 'or',
  'desktop.start.session.eyebrow': 'Current session',
  'desktop.start.session.logout': 'Switch user',
  'desktop.start.session.loginType': 'Login method',
  'desktop.start.session.role': 'Role',
  'desktop.start.session.loginTime': 'Last login',
  'desktop.start.session.accessKey': 'Access key',
  'desktop.start.session.loginTypeManual': 'Access key',
  'desktop.start.session.loginTypeQr': 'QR code',
  'desktop.start.session.roleAdmin': 'Admin',
  'desktop.start.session.roleKitchen': 'Kitchen',
  'desktop.start.session.roleStaff': 'Staff',
  'desktop.start.session.roleGuest': 'Guest',
  'desktop.start.quick.eyebrow': 'Quick start',
  'desktop.start.quick.title': 'Choose the next step',
  'desktop.start.quick.body': 'Open the working mode you need.',
  'desktop.start.quick.primaryEyebrow': 'Primary route',
  'desktop.start.quick.ready': 'The local system is ready',
  'desktop.start.quick.admin': 'Open admin',
  'desktop.start.quick.kitchen': 'Open kitchen',
  'desktop.start.quick.tables': 'Open tables',
  'desktop.start.quick.myTable': 'Open my table',
  'desktop.start.quick.qrDemo': 'Open table QR demo',
  'desktop.start.qr.eyebrow': 'QR access',
  'desktop.start.qr.title': 'Guest access',
  'desktop.start.qr.body': 'Open the link to enter the same local route as a guest.',
  'desktop.start.qr.scanTitle': 'QR leads into the same local entry',
  'desktop.start.qr.scanBody': 'A guest or staff member can open the app through a token link.',
  'desktop.start.qr.detected': 'QR token detected',
  'desktop.start.qr.demoEyebrow': 'Guest access',
  'desktop.start.qr.demoTitle': 'Guest link',
  'desktop.start.qr.openGuest': 'Open as guest',
  'desktop.start.qr.copyLink': 'Copy link',
  'desktop.nav.signOut': 'Sign out',
  'desktop.nav.openPortal': 'Open portal',
  'desktop.nav.backToLocal': 'Back to local app',
  'desktop.start.capability.local': 'Confidential local work on the venue computer',
  'desktop.start.capability.offline': 'Offline and autonomous operation when needed',
  'desktop.start.capability.menu': 'Menu, showcase, and screen setup',
  'desktop.start.capability.tables': 'Table service and touch-screen tools',
  'desktop.start.capability.admin': 'Admin and kitchen control in one local system',
  'desktop.start.capability.portal': 'Public presence and portal advertising layer',
  'desktop.start.capability.backup': 'Backup and recovery readiness',
  'desktop.start.capability.qr': 'Continue the same table on a phone via QR',

  // Update banner
  'update.available': 'App update available',
  'update.download': 'Download update',

  // Venue details panel
  'venue.close': 'Close',
  'venue.address': 'Address',
  'venue.phone': 'Phone',
  'venue.hours': 'Opening hours',
  'venue.status': 'Status',
  'venue.open': 'Open',
  'venue.closed': 'Closed now',
  'venue.occupancy': 'Real-time occupancy',
  'venue.occupancyDetail': 'Active tables with orders: {active} of {total}',
  'venue.navigation': 'Navigation',
  'venue.distance': 'Distance:',
  'venue.openMaps': 'Open in Maps',
  'venue.walking': 'Walking',
  'venue.driving': 'Driving',
  'venue.showMenu': 'Show menu',
  'venue.hideMenu': 'Hide menu',
  'venue.entrancePhotoSoon': 'Entrance photo coming soon',
  'venue.menuOnlyLocal': 'Menu is only available for the connected venue.',
  'venue.menuNoConnection': 'Menu is temporarily unavailable: no connection to the local app.',
  'venue.menuClosed': 'The venue is currently closed. Menu unavailable.',
  'venue.reviews': 'Reviews',
  'venue.reviewAuthorPlaceholder': 'Write your name (optional)',
  'venue.reviewPlaceholder': 'Write a short review about the venue...',
  'venue.saveReview': 'Save review',
  'venue.reportVenue': 'Report',
  'venue.reportReview': 'Report review',
  'venue.reportTitle': 'Report venue',
  'venue.reportReviewTitle': 'Report review',
  'venue.reportHelp': 'This report will go to the portal owner for moderation.',
  'venue.reportReason': 'Reason',
  'venue.reportComment': 'Comment',
  'venue.reportCommentPlaceholder': 'Briefly describe the issue',
  'venue.reportContact': 'Contact for reply (optional)',
  'venue.reportSend': 'Send report',
  'venue.reportSending': 'Sending...',
  'venue.reportCancel': 'Cancel',
  'venue.reportSuccess': 'Report sent. Thank you, we will review it.',
  'venue.reportError': 'Could not send report',
  'venue.reportReason.wrong_location': 'Wrong location',
  'venue.reportReason.fake_venue': 'Fake venue',
  'venue.reportReason.offensive_content': 'Offensive content',
  'venue.reportReason.wrong_menu': 'Wrong menu',
  'venue.reportReason.wrong_prices': 'Wrong prices',
  'venue.reportReason.privacy': 'Personal data',
  'venue.reportReason.spam': 'Spam',
  'venue.reportReason.other': 'Other',

  // Cookie consent banner
  'cookie.dialogLabel': 'Cookie consent',
  'cookie.heading': 'We use cookies',
  'cookie.body': 'Necessary cookies keep the site running. Analytics cookies (Google Analytics) help us improve the service — we do not sell this data.',
  'cookie.moreInfo': 'More info',
  'cookie.privacy': 'Privacy',
  'cookie.acceptAll': 'Accept all',
  'cookie.necessaryOnly': 'Only necessary',

  // Consent text in modals
  'consent.usingService': 'By using the service, you agree to our',
  'consent.installing': 'By installing the app, you agree to our',
  'consent.privacyPolicy': 'Privacy Policy',
  'consent.and': 'and',
  'consent.terms': 'Terms of Use',

  // Legal page navigation & common
  'legal.backToHome': 'Back to home',
  'legal.edition': 'Edition of May 17, 2025. Effective from the date of publication.',
  'legal.footer': '© 2024–2025 NGO "Center for Psychological and Physical Health". HELFER is a free non-profit project.',
  'legal.nav.privacy': 'Privacy',
  'legal.nav.terms': 'Terms of Use',
  'legal.nav.cookies': 'Cookies',
  'legal.nav.geolocation': 'Geolocation',
  'legal.nav.venueRules': 'Venue Rules',
  'legal.nav.accountDeletion': 'Account deletion',
  'legal.privacy.badge': 'HELFER · NGO "CPHH"',
  'legal.privacy.title': 'Privacy Policy',
  'legal.terms.badge': 'HELFER · NGO "CPHH"',
  'legal.terms.title': 'Terms of Use',
  'legal.cookies.badge': 'HELFER · NGO "CPHH"',
  'legal.cookies.title': 'Cookie & Local Storage Policy',
  'legal.geolocation.badge': 'HELFER · NGO "CPHH"',
  'legal.geolocation.title': 'Geolocation — Why and How',
  'legal.geolocation.subtitle': 'Plain language explanation of how HELFER uses location data.',
  'legal.venueRules.badge': 'HELFER · NGO "CPHH"',
  'legal.venueRules.title': 'Rules for Venues',
  'legal.venueRules.subtitle': 'Required reading before registering on HELFER.',
  'portal.footer.free': 'Free for everyone.',
  'portal.footer.nonProfit': 'We are a non-profit project (NGO)',

  'locationGuide.title': 'Allow Location Access',
  'locationGuide.body': 'To find nearby venues the portal needs location access. Please enable it in your system settings.',
  'locationGuide.steps': 'How to enable on macOS',
  'locationGuide.mac.step1': 'Open System Settings (Apple menu → System Settings)',
  'locationGuide.mac.step2': 'Go to Privacy & Security',
  'locationGuide.mac.step3': 'Click Location Services',
  'locationGuide.mac.step4': 'Find "Cafe Local" in the list and turn on the toggle',
  'locationGuide.win.step1': 'Open Windows Settings (Win + I)',
  'locationGuide.win.step2': 'Go to Privacy & Security',
  'locationGuide.win.step3': 'Click Location',
  'locationGuide.win.step4': 'Turn on "Let apps access your location"',
  'locationGuide.win.step5': 'Scroll down and make sure "Desktop apps" access is also enabled',
  'locationGuide.linux': 'Make sure location access is allowed for this app in your system settings.',
  'locationGuide.openSettings': 'Open System Settings',
  'locationGuide.opening': 'Opening settings…',
  'locationGuide.retry': 'I enabled it — check again',
  'locationGuide.retrying': 'Checking…',
  'locationGuide.skip': 'Skip — continue without location',
};
